// API configuration
// Uses runtime config from window (injected at runtime in production) or build-time env vars
const getRuntimeConfig = (key) => {
  // Check for runtime config (injected at runtime in production)
  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
    return window.__RUNTIME_CONFIG__[key];
  }
  // Fall back to build-time env vars (for development)
  return process.env[key];
};

const getApiBaseUrl = () => {
  // Check for runtime config first (production)
  const runtimeUrl = getRuntimeConfig('REACT_APP_API_BASE_URL');
  if (runtimeUrl) {
    return runtimeUrl;
  }
  
  // Check for build-time env var
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // In production (same origin), use relative URLs
  // In development, use localhost backend
  if (process.env.NODE_ENV === 'production') {
    return ''; // Empty string means relative URLs (same origin)
  }
  
  // Default to localhost backend for development
  return 'http://localhost:3001';
};

export const API_BASE_URL = getApiBaseUrl();

// API endpoints
export const API_ENDPOINTS = {
  CHAT: `${API_BASE_URL}/api/chat`,
  ILLUSTRATE: `${API_BASE_URL}/api/illustrate`,
};

